module.exports = __webpack_public_path__ + "img/civil_case_part_3_splash.d9e609cf.jpg";